export default __webpack_public_path__ + "static/Pantaley-Stoyanov-4ff4b8db615bb35084d54a312bbe2279.jpg";